
<link rel="stylesheet"
href="https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.2.0/adyen.css"
integrity="sha384-oT6lIQpTr+nOu+yFBPn8mSMkNQID9wuEoTw8lmg2bcrFoDu/Ae8DhJVj+T5cUmsM"
crossorigin="anonymous">

<!-- <div class="wrapper-block">
    <div class="title-dialog">

        <p>PayOnline</p>
    </div>
    <div class="dialog-body">
        <div class="p-grid">
            <div class="p-col-12 input-group">
                <div id="payment-page">
                    <div class="container">
                      <div class="payment-container">
                        <div #hook id="dropin" class="payment"></div>
                      </div>
                    </div>
                  </div>
                
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <div class="cta">

        </div>
    </div>
</div> -->

<div class="container mt-5">
    <div class="grid">
        <div class="col-12">
            <div class="wrapper-block wrapper-position">
                <div class="title-dialog">
                    <p>Pay Online</p>
                </div>
                <div class="dialog-body">
                    <div class="grid">
                        <div class="col-12 input-grp">
                            <div #hook id="dropin" class="payment"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>





  


